const mutations = [
  {
    id: 'simple-mutation',
    language: 'graphql',
    title: 'Simple mutation',
    description:
      'Create, Update and Delete mutations are automatically generated for all your models in your schema.',
    children: `mutation {
  createPage(
    data: {
      title: "GraphCMS mutation API",
      slug: "graphcms-mutation-api"
    }
  ) {
    id
    title
    slug
  }
}`,
  },
  {
    id: 'publishing',
    language: 'graphql',
    title: 'Publishing',
    description:
      'Publish or unpublish content entries with a single GraphQL mutation.',
    children: `mutation {
  publishPage(
    where: {
      slug: "graphcms-mutation-api"
    },
    to: PUBLISHED
  ) {
    stage
  }
}`,
  },
];

export default mutations;
